export const BASE_URL = "https://api.str8aligners.com/"

export const LOGIN = "api/Auth/login"; // POST
export const REFRESH_TOKEN = "api/Auth/refresh"; // POST

export const POLICIES = "api/Policy/"; // GET
export const QUESTIONS = "api/EConsultationQuestions"; // GET
export const GOALS = "api/EConsultationQuestions/goals"; // GET
export const ADD_GOAL = "api/EConsultationQuestions/addgoal"; // POST
export const FAQS = "api/Faq"; // GET
export const ABOUT_US = "api/Aboutus"; // GET
export const USERS = "api/Users/users/by-role"; // GET
